import { render, staticRenderFns } from "./WhatToDo.vue?vue&type=template&id=2b2521ca&scoped=true&"
import script from "./WhatToDo.vue?vue&type=script&lang=js&"
export * from "./WhatToDo.vue?vue&type=script&lang=js&"
import style0 from "./WhatToDo.vue?vue&type=style&index=0&id=2b2521ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2521ca",
  null
  
)

export default component.exports